import { env } from '@/env';
import mixpanel, { Callback, Dict, RequestOptions } from 'mixpanel-browser';

// Source identifier for filtering in Mixpanel
const SOURCE = 'access-registration';

const MIXPANEL_DEBUG = env.MIXPANEL_DEBUG === 'true';

class AnalyticsManager {
  isInitialized = false;

  constructor() {
    if (env.MIXPANEL_TOKEN) {
      mixpanel.init(env.MIXPANEL_TOKEN, {
        api_host: env.MIXPANEL_API_HOST,
        debug: MIXPANEL_DEBUG,
        ignore_dnt: env.IS_PROD,
        cookie_domain: window.location.hostname,
        cross_subdomain_cookie: false,
      });

      // Register source as a super property (included in all events)
      mixpanel.register({
        source: SOURCE,
        appVersion: env.APP_VERSION,
      });

      this.isInitialized = true;
    }
  }

  registerUser(userId: string) {
    if (this.isInitialized) {
      mixpanel.register({
        userId,
        appVersion: env.APP_VERSION,
      });
    }
  }

  setUserProperties(properties: Dict) {
    if (this.isInitialized) {
      mixpanel.register_once(properties);
    }
  }

  identifyUser(analyticsID: string) {
    if (this.isInitialized) {
      mixpanel.identify(analyticsID);
    }
  }

  track(
    eventName: string,
    properties: Dict = {},
    options: RequestOptions = {},
    callback: Callback = () => {},
  ) {
    if (this.isInitialized) {
      mixpanel.track(eventName, properties, options, callback);
    } else if (env.IS_DEV) {
      console.log('[Analytics] Track:', eventName, '(properties hidden)');
    }
  }

  trackError(eventName: string, properties: Dict = {}) {
    this.track(eventName, { ...properties, isError: true });
  }

  reset() {
    if (this.isInitialized) {
      mixpanel.reset();
    }
  }
}

const analytics = new AnalyticsManager();

export default analytics;
